import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import NewsCard from "@/components/feature/NewsCard";
import SectionHeading from "@/components/feature/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import TopicSection from "./components/TopicSection";
import HotRanking from "./components/HotRanking";
import CommentFeed from "./components/CommentFeed";
import useSeo from "@/hooks/useSeo";
import { hotComments } from "@/mocks/news";
import type { HotComment } from "@/types/news";
import {
  filterArticles,
  getFeatureArticles,
  getHotArticles,
  getLatestArticles,
} from "@/utils/articles";

export default function Home() {
  useSeo({
    title: "51黑料网 - 权威黑料爆料资讯平台",
    description:
      "51黑料网提供最新最全的黑料爆料资讯，涵盖明星、娱乐、社会热点等多领域内容，帮助用户快速掌握第一手黑料信息。",
    keywords: "51黑料网,黑料资讯,爆料平台,娱乐黑料,社会黑料,最新黑料,权威黑料",
  });

  const featured = getFeatureArticles();
  const hotArticles = getHotArticles(8);
  const latest = getLatestArticles(5);
  const starArticles = filterArticles({ category: "star", sort: "latest" }).slice(0, 3);
  const societyArticles = filterArticles({ category: "society", sort: "latest" }).slice(0, 3);
  const entertainmentArticles = filterArticles({
    category: "entertainment",
    sort: "latest",
  }).slice(0, 4);
  const topicArticles = filterArticles({ category: "entertainment", sort: "latest" }).slice(0, 3);
  const tickerItems = [...latest, ...latest];

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <div className="max-w-portal mx-auto px-4 md:px-6">
          <div className="mt-4 flex items-center h-10 rounded-md overflow-hidden border border-primary-100 bg-primary-50">
            <span className="shrink-0 h-full px-3 flex items-center gap-1.5 bg-primary-600 text-background-50 text-xs font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-soft-pulse" />
              实时爆料
            </span>
            <div className="relative flex-1 overflow-hidden h-full">
              <div className="absolute inset-y-0 left-0 flex items-center w-max animate-marquee hover:[animation-play-state:paused]">
                {tickerItems.map((article, index) => (
                  <Link
                    key={`${article.id}-${index}`}
                    to={`/detail/${article.id}`}
                    className="flex items-center gap-2 px-4 text-xs md:text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    <span className="w-1 h-1 rounded-full bg-primary-300" />
                    {article.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-5 md:mt-6 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_340px] gap-6 lg:gap-8">
            <div className="min-w-0 space-y-6 md:space-y-7">
              <HeroCarousel articles={featured} />

              <TopicSection
                title="《夜航星》风波全记录：剪辑、赛制与一场没有说完的直播"
                description="从一段被删掉的备采，到凌晨三点的声明，我们把两周内的公开信息按时间顺序重新排了一遍，包括两份不同的赛制流程表。"
                articles={topicArticles}
              />

              <section>
                <SectionHeading
                  title="明星爆料"
                  eyebrow="CELEBRITY"
                  link={{ to: "/category/star", label: "更多明星黑料" }}
                />
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                  {starArticles.map((article) => (
                    <NewsCard key={article.id} article={article} />
                  ))}
                </div>
              </section>

              <section>
                <SectionHeading
                  title="社会热点追踪"
                  eyebrow="SOCIETY"
                  link={{ to: "/category/society", label: "进入社会栏目" }}
                />
                <div className="space-y-3">
                  {societyArticles.map((article) => (
                    <NewsCard key={article.id} article={article} variant="list" />
                  ))}
                </div>
              </section>
            </div>

            <aside className="min-w-0 space-y-5">
              <HotRanking articles={hotArticles} />
              <CommentFeed comments={hotComments as HotComment[]} />

              <div className="rounded-lg overflow-hidden bg-primary-700 text-background-50 p-5">
                <span className="inline-flex items-center gap-1.5 text-[11px] px-2 py-0.5 rounded-md bg-background-50/15 border border-background-50/20">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-shield-check-line" aria-hidden="true" />
                  </span>
                  线索征集
                </span>
                <h2 className="mt-3 font-heading text-xl font-black leading-snug">
                  有料要爆？
                  <br />
                  我们帮你把细节说清楚
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-background-50/80">
                  接受匿名投稿，所有线索都会经过至少两次交叉核实。你的身份信息不会被公开。
                </p>
                <Link
                  to="/contact"
                  className="mt-4 inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-send-plane-line" aria-hidden="true" />
                  </span>
                  提交爆料线索
                </Link>
              </div>
            </aside>
          </div>

          <section className="mt-10 md:mt-12">
            <SectionHeading
              title="娱乐八卦精选"
              eyebrow="ENTERTAINMENT"
              description="综艺、音乐与演出市场的第一现场"
              link={{ to: "/category/entertainment", label: "查看全部娱乐资讯" }}
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {entertainmentArticles.map((article) => (
                <NewsCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          <section className="mt-10 md:mt-12 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
            <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-5 h-5 flex items-center justify-center text-primary-600">
                  <i className="ri-error-warning-line text-lg" aria-hidden="true" />
                </span>
                <h2 className="font-heading text-lg md:text-xl font-black text-foreground-950">
                  本周最值得追的一条线
                </h2>
              </div>
              <p className="text-sm leading-relaxed text-foreground-600">
                “爆料”从来不只是一句惊人的标题。我们把每一条线索拆成时间、当事人、回应和可核对的材料，
                让你在转发之前，先知道自己在转什么。
              </p>
              <div className="mt-5 grid grid-cols-3 gap-3">
                {[
                  { value: "15", label: "条深度爆料" },
                  { value: "3", label: "个内容栏目" },
                  { value: "24h", label: "线索跟进" },
                ].map((stat) => (
                  <div key={stat.label} className="rounded-md bg-background-50 border border-background-200 px-3 py-3">
                    <p className="font-label text-xl md:text-2xl font-bold text-primary-700">{stat.value}</p>
                    <p className="mt-0.5 text-[11px] text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col justify-between">
              <div>
                <h2 className="font-heading text-lg font-black text-foreground-950">关于 51黑料网</h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  一个把“核实”放在“爆”前面的资讯门户。明星、娱乐、社会三条线，每天更新。
                </p>
              </div>
              <Link
                to="/about"
                className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-primary-600 transition-colors cursor-pointer"
              >
                了解我们的内容准则
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </Link>
            </div>
          </section>
        </div>
      </main>

      <SiteFooter />
      <BackToTop />
    </div>
  );
}